// extracted by mini-css-extract-plugin
module.exports = {"actions":"PLUSetting_actions__2-er6","btn":"PLUSetting_btn__bA7qQ","icon":"PLUSetting_icon__3ut_4"};